module.exports = __webpack_public_path__ + "img/bailey-logo-white.3058ab3d.png";